<template>
  <a-modal :title="`【${user.name}】的积分`"
           :width="600"
           :open="modal"
           @cancel="cancelCk">
    <a-space class="nav-no-title">
      <div>当前积分
        <a-tag :bordered="false" color="green">{{ current }}</a-tag>
      </div>
      <a-select :options="typeList"
                v-model:value="typeId"
                size="small"
                @change="query"/>
      <a-button size="small" type="primary" @click="addCk">调整积分</a-button>
    </a-space>

    <a-table size="small"
             :columns="columns"
             :data-source="source"
             :loading="loading"
             :pagination="pagination"
             :onChange="handlePage">
      <template v-slot:bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'num'">
          <a-space>
            <a-tag :bordered="false" :color="record.num >= 0 ? 'green' : 'red'">{{ record.num }}</a-tag>
          </a-space>
        </template>

        <template v-else-if="column.dataIndex === 'state'">
          <a-tag v-if="record.state === 0" :bordered="false" color="red">失效</a-tag>
          <a-tag v-else-if="record.state === 1" :bordered="false" color="orange">锁定</a-tag>
          <a-tag v-else :bordered="false" color="green">正常</a-tag>
        </template>

        <template v-else>
          {{ record[column.dataIndex] }}
        </template>
      </template>
    </a-table>

    <template #footer></template>
  </a-modal>

  <add-point-modal ref="addPoint" @refresh="query"/>
</template>

<script setup>
import {ref} from 'vue'
import axios from '@/axios'

import AddPointModal from '@/views/user/AddOrderPoint.vue'

const typeId = ref(0)
const current = ref(0)

const source = ref([])

const user = ref({})

const modal = ref(false)
const loading = ref(false)

const addPoint = ref(null)

const pagination = ref({
  showSizeChanger: true,
  defaultCurrent: 1,
  defaultPageSize: 10,
  current: 1,
  pageSize: 10,
  total: 0,
  onShowSizeChange: (current, size) => {
    pagination.value.current = 1
    pagination.value.pageSize = size
    query()
  }
})

const columns = [
  {
    key: 'id',
    title: 'ID',
    dataIndex: 'id',
  }, {
    key: 'orderId',
    title: '订单ID',
    dataIndex: 'orderId',
  }, {
    key: 'num',
    title: '数值',
    dataIndex: 'num',
  }, {
    key: 'state',
    title: '状态',
    dataIndex: 'state',
  }, {
    key: 'createTime',
    title: '时间',
    dataIndex: 'createTime',
  },
]

let typeList = []

function query() {
  loading.value = true

  axios.get(`/user/${user.value.id}/order-point/${typeId.value}`, {
    params: {
      page: pagination.value.current,
      size: pagination.value.pageSize,
    }
  }).then((res) => {
    loading.value = false

    if (res.code === 1) {
      pagination.value.current = res.data.page
      pagination.value.total = res.data.total
      source.value = res.data.data
      current.value = res.data.current
    }

    modal.value = true
  })
}

function handlePage(param) {
  pagination.value.current = param.current
  pagination.value.pageSize = param.pageSize
  query()
}

function type() {
  axios.get('/config-opt/order_point_cls', {
    params: {
      nameOnly: 1,
    }
  }).then((res) => {
    if (res.code === 1) {
      typeList = res.data
      if (typeList.length) {
        typeId.value = typeList[0].value
      }
      query()
    }
  })
}

function openCk(record) {
  user.value = record
  type()
}

function addCk() {
  addPoint.value.openCk(user.value.id, typeId.value)
}

function cancelCk() {
  modal.value = false
}

defineExpose({openCk})
</script>